import { PermissionsCategory } from "src/app/auth/permissions";

@PermissionsCategory("DataListPermissions")
export class DataListPermissions {
    static readonly None = 0;
    static readonly View = 1;
    static readonly Edit = 2;
}